import React from 'react';

const Error = ({error}) => (
    <div className="rounded-md bg-red-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">There was an error verifiying item</h3>
          <div className="mt-2 text-sm text-red-700">
              {error}
          </div>
        </div>
      </div>
    </div>
);

export default Error;
